module.exports = __webpack_public_path__ + "img/UTESCA-3.4d734a12.jpg";